import { injectReducer } from '../../store/reducers';
import { injectSagas } from '../../store/sagas';


export default store => ({
  path : 'forgotten-password',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const ForgottenPasswordContainer = require('./containers/ForgottenPassword.js').default;
      const reducer = require('reducers/user').default;
      const sagas = require('sagas/sagas').default;

      injectReducer(store, { key: 'user', reducer });
      injectSagas(store, { key: 'sagas', sagas });

      cb(null, ForgottenPasswordContainer);
    }, 'forgottenPassword');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/ForgottenPassword/index.js